import { AxiosError } from 'axios';
import snakeCase from 'lodash/fp/snakeCase';
import replace from 'lodash/fp/replace';
import compose from 'lodash/fp/compose';

export function isAxiosError(error: unknown): error is AxiosError {
  return (error as AxiosError).isAxiosError === true;
}

function parseOrKebabCase(str: string) {
  try {
    return JSON.parse(str);
  } catch (error) {
    const fallback = compose(replace(/_/g, '.'), snakeCase)(str);
    return { error: fallback };
  }
}

export function parseAxiosError(error: unknown) {
  if (!isAxiosError(error)) return null;

  try {
    const err = parseOrKebabCase(error.response?.data?.message ?? '');
    return err;
  } catch (error) {
    return null;
  }
}
